export enum ReferralStatus {
  AWAITING_TO_ACCEPT = 'awaiting-to-accept',
  ACCEPTED_SIGNUP = 'accepted-signup',
  ACCEPTED_TRIAL = 'accepted-trial',
  WAITING_FOR_APPROVAL = 'waiting-for-approval',
  REWARD_DELIVERED = 'reward-delivered',
  REJECTED = 'rejected'
}
